import { connect } from 'react-redux';
import DashboardAdminScreen from '../components/DashboardAdminScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  return {
    activeId: storage.get(findStorageType(), 'partnershipId'),
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const DashboardAdminScreenContainer =
  connect(mapStateToProps)(DashboardAdminScreen);

export default DashboardAdminScreenContainer;
